import { isEmpty } from 'lodash';
import Typography from 'components/Typography';
import { Button } from 'components/Input/Button';

import { useAnalytics } from 'hooks/useAnalytics';
import { useAppConfig } from 'hooks/appConfig';
import { useAuthentication } from 'hooks/authentication';

import { description, signIn } from './content';
import { StyledAccountWrapper } from './styles';
import { ANALYTICS } from 'analytics/constants';
import { CHAT_UI_PREFIX } from 'constants/id';
import { AnalyticClickedDetailsType } from 'analytics/types';

const Account = () => {
  const { trackEvent } = useAnalytics();
  const { appConfigState } = useAppConfig();
  const { authenticationState } = useAuthentication();

  // mobile handles auth separately. On web, user obj will exist in state if authenticated
  if (appConfigState.isNativeMobileApp || !isEmpty(authenticationState.user)) {
    return null;
  }

  const $headerPluginEvents = document.getElementById('header-plugin-events');
  const buttonId = `${CHAT_UI_PREFIX}-btn-sign-in`;

  const handleOnClickSignIn = () => {
    if ($headerPluginEvents) {
      const openModalEvent = new Event('header|account-modal|open');
      $headerPluginEvents.dispatchEvent(openModalEvent);
    }
  };

  return (
    <StyledAccountWrapper id='account-wrapper'>
      <Typography as='p' color='inverse' variant='body' size='sm'>
        {description}
      </Typography>
      <Button
        id={buttonId}
        variant='inverse'
        size='medium'
        priority='secondary'
        onClick={(e) => {
          trackEvent({
            analyticEvent: ANALYTICS.EVENT.CLICKED,
            details: {
              analytic_click_id: buttonId,
              content: signIn,
            } as AnalyticClickedDetailsType,
          });
          handleOnClickSignIn();
        }}
      >
        {signIn}
      </Button>
    </StyledAccountWrapper>
  );
};

export default Account;
